import React from 'react';
import { LoadingAnimationWrapper } from './LoadingAnimation.styles';

export const LoadingAnimation: React.FC = () => {
  return (
    <LoadingAnimationWrapper className="animation-wrapper">
      <div className="particle particle-1"></div>
      <div className="particle particle-2"></div>
      <div className="particle particle-3"></div>
      <div className="particle particle-4"></div>
    </LoadingAnimationWrapper>
  );
};
